import React from 'react';
import pt from 'prop-types';
import {Section, BgImage, Content, H1, H2, Icon} from './HomeSection.styles';
import {getBowserState} from '@epic-core/common';
import {generateRoutePath} from '@epic-core/common';
import {withRouter} from 'react-router';

const HomeSection = ({title, icon, subTitle, desc, image = {}, href, history}) => {
    const {mobile, tablet} = getBowserState();

    let imageUrl = image.desktopImage;
    if (tablet) imageUrl = image.tabletImage;
    if (mobile) imageUrl = image.mobileImage;

    let internalLink;
    if (href !== undefined && href.indexOf('http') !== 0) {
        internalLink = generateRoutePath(href);
    }

    return (
        <Section
            onClick={e => {
                if (internalLink) {
                    e.preventDefault();
                    history.push(internalLink);
                }
            }}
            href={href}>
            <BgImage imageUrl={imageUrl} />
            <Content>
                <H1 title={title} phDl={false} />
                <H2 title={subTitle} phDl={false} />
                <Icon image={icon} alt={desc} />
            </Content>
        </Section>
    );
};

HomeSection.propTypes = {
    title: pt.string,
    subTitle: pt.string,
    icon: pt.string,
    desc: pt.string,
    image: pt.object,
    href: pt.string,
    history: pt.object
};

export default withRouter(HomeSection);
